// src/store/store.js

import {
  applyMiddleware,
  combineReducers,
  compose,
  createStore,
} from "redux";

import thunk from "redux-thunk";

// ============================================================
// OLD REDUCERS
// ============================================================

import {
  PostsReducer,
  toggleMenu,
} from "./reducers/PostsReducer";

import todoReducers from "./reducers/Reducers";

// ============================================================
// AUTH / COMMON
// ============================================================

import authReducer from "./slices/authSlice";
import tenantReducer from "./slices/tenantSlice";

import dashboardReducer from "./slices/dashboardSlice";

import adminPermReducer from "./slices/adminPermissionSlice";
import PermissionReducer from "./slices/permissionSlice";

// ============================================================
// MASTERS
// ============================================================

import wardsReducer from "./slices/wardsSlice";
import agentsReducer from "./slices/agentsSlice";

import salesExecutiveReducer from "./slices/salesExecutiveSlice";

import meterTypesReducer from "./slices/meterTypesSlice";

import panchayathMasterReducer from "./slices/panchayathMasterSlice";

import wasteTypeMasterReducer from "./slices/wasteTypeMasterSlice";

import slrmTypesReducer from "./slices/slrmTypesSlice";

import districtTalukMasterReducer from "./slices/districtTalukMasterSlice";

import incomeExpenseMastersReducer from "./slices/incomeExpenseMastersSlice";

// ============================================================
// HOUSE
// ============================================================

import houseMasterReducer from "./slices/houseMasterSlice";
import houseDetailsReducer from "./slices/houseDetailsSlice";
import houseProfileReducer from "./slices/houseProfileSlice";

import houseBillsReducer from "./slices/houseBillsSlice";

import houseSettingsReducer from "./slices/houseSettingsSlice";

import houseOtherSettingsReducer from "./slices/houseOtherSettingsSlice";

import houseToolsReducer from "./slices/houseToolsSlice";

// ============================================================
// WATER / SLRM
// ============================================================

import waterBillsReducer from "./slices/waterBillsSlice";

import waterbillSettingsReducer from "./slices/waterbillSettingsSlice";

import slrmBillsReducer from "./slices/slrmBillsSlice";

// ============================================================
// RECEIPTS / DISCOUNTS / RESET
// ============================================================

import receiptsReducer from "./slices/receiptsSlice";

import discountsReducer from "./slices/discountsSlice";

import meterResetReducer from "./slices/meterResetSlice";

// ============================================================
// SETTINGS
// ============================================================

import generalSettingsReducer from "./slices/generalSettingsSlice";

import changePasswordReducer from "./slices/changePasswordSlice";

import financialYearsReducer from "./slices/financialYearSlice";

import backupDatabaseReducer from "./slices/backupDatabaseSlice";

// ============================================================
// USERS / PANCHAYATH
// ============================================================

import userPanAssignReducer from "./slices/userPanchayathAssignSlice";

import userMasterReducer from "./slices/userMasterSlice";

// ============================================================
// INCOME / EXPENSE
// ============================================================

import incomeExpenseReducer from "./slices/incomeExpenseSlice";

import incomeExpenseReportReducer from "./slices/incomeExpenseReportSlice";

// ============================================================
// REPORTS
// ============================================================

import houseListReportReducer from "./slices/houseListReportSlice";

import balanceReportReducer from "./slices/balanceReportSlice";

import waterBillReportReducer from "./slices/waterBillReportSlice";

import receiptReportReducer from "./slices/receiptReportSlice";

import disconnectionReportReducer from "./slices/disconnectionReportSlice";

import pendingReportReducer from "./slices/pendingReportSlice";

import waterDcbReducer from "./slices/waterDcbSlice";

import houseSummaryReportReducer from "./slices/houseSummaryReportSlice";

import slrmBillReportReducer from "./slices/slrmBillReportSlice";

import slrmDcbReducer from "./slices/slrmDcbSlice";

import kannadaWasteReportReducer from "./slices/kannadaWasteReportSlice";

import gpIncomeExpenseReportReducer from "./slices/gpIncomeExpenseReportSlice";

import zeroBillReportReducer from "./slices/zeroBillReportSlice";


import panchayathBillingReducer
  from "./slices/panchayathBillingSlice";

  import accountDashboardReducer
  from "./slices/accountDashboardSlice";

  import smsGatewayReducer from "./slices/smsGatewaySlice";


  import houseApprovalSettingsReducer from "./slices/houseApprovalSettingsSlice";

  import houseConnectionReducer
  from "./slices/houseConnectionSlice";

 import panchayathSubscriptionReportsReducer from "./slices/panchayathSubscriptionReportsSlice";



import receiptApprovalsReducer
  from "./slices/receiptApprovalsSlice";
// ============================================================
// MIDDLEWARE
// ============================================================

const middleware = applyMiddleware(thunk);

// ============================================================
// REDUX DEVTOOLS
// ============================================================

const composeEnhancers =
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ||
  compose;

// ============================================================
// ROOT REDUCER
// ============================================================

const rootReducer = combineReducers({
  // ==========================================================
  // OLD / LAYOUT
  // ==========================================================

  sideMenu: toggleMenu,

  posts: PostsReducer,

  todoReducers,

  // ==========================================================
  // AUTH / COMMON
  // ==========================================================

  auth: authReducer,

  tenant: tenantReducer,

  dashboard: dashboardReducer,

  adminPerm: adminPermReducer,

  permissions: PermissionReducer,

  // ==========================================================
  // MASTERS
  // ==========================================================

  wards: wardsReducer,

  agents: agentsReducer,

  // ✅ NEW
  salesExecutives: salesExecutiveReducer,

  meterTypes: meterTypesReducer,

  panchayathMaster:
    panchayathMasterReducer,

  wasteTypeMaster:
    wasteTypeMasterReducer,

  slrmTypes: slrmTypesReducer,

  districtTalukMaster:
    districtTalukMasterReducer,

  incomeExpenseMasters:
    incomeExpenseMastersReducer,

  // ==========================================================
  // HOUSE
  // ==========================================================

  houseMaster: houseMasterReducer,

  houseDetails: houseDetailsReducer,

  houseProfile: houseProfileReducer,

  houseBills: houseBillsReducer,

  houseSettings: houseSettingsReducer,

  houseOtherSettings:
    houseOtherSettingsReducer,

  houseTools: houseToolsReducer,

  // ==========================================================
  // WATER / SLRM
  // ==========================================================

  waterBills: waterBillsReducer,

  waterbillSettings:
    waterbillSettingsReducer,

  slrmBills: slrmBillsReducer,

  // ==========================================================
  // RECEIPTS / DISCOUNTS / RESET
  // ==========================================================

  receipts: receiptsReducer,

  discounts: discountsReducer,

  meterReset: meterResetReducer,

  // ==========================================================
  // SETTINGS
  // ==========================================================

  generalSettings:
    generalSettingsReducer,

  changePassword:
    changePasswordReducer,

  financialYears:
    financialYearsReducer,

  backupDatabase:
    backupDatabaseReducer,

  // ==========================================================
  // USERS / PANCHAYATH
  // ==========================================================

  userPanAssign:
    userPanAssignReducer,

  userMaster:
    userMasterReducer,

  // ==========================================================
  // INCOME / EXPENSE
  // ==========================================================

  incomeExpense:
    incomeExpenseReducer,

  incomeExpenseReport:
    incomeExpenseReportReducer,

  // ==========================================================
  // REPORTS
  // ==========================================================

  houseListReport:
    houseListReportReducer,

  balanceReport:
    balanceReportReducer,

  waterBillReport:
    waterBillReportReducer,

  receiptReport:
    receiptReportReducer,

  disconnectionReport:
    disconnectionReportReducer,

  pendingReport:
    pendingReportReducer,

  waterDcb:
    waterDcbReducer,

  houseSummaryReport:
    houseSummaryReportReducer,

  slrmBillReport:
    slrmBillReportReducer,

  slrmDcb:
    slrmDcbReducer,

  kannadaWasteReport:
    kannadaWasteReportReducer,

  gpIncomeExpenseReport:
    gpIncomeExpenseReportReducer,

  zeroBillReport:
    zeroBillReportReducer,

  panchayathBilling:
    panchayathBillingReducer,

    accountDashboard:
  accountDashboardReducer,
  smsGateway:
  smsGatewayReducer,

  houseApprovalSettings:
  houseApprovalSettingsReducer,

  houseConnection:
  houseConnectionReducer,

  panchayathSubscriptionReports:
  panchayathSubscriptionReportsReducer,


  receiptApprovals:
  receiptApprovalsReducer,

});

// ============================================================
// STORE
// ============================================================

export const store = createStore(
  rootReducer,
  composeEnhancers(middleware)
);